<template>
  <el-container>
    <el-header>
      <el-row type="flex" justify="center">
        <el-col :span="24">
          <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect">
            <el-menu-item style="margin-left: 30%"  index="1">首页</el-menu-item>
            <el-menu-item style="margin-left: 80px" index="2">公司简介</el-menu-item>
<!--            <el-menu-item style="margin-left: 80px" index="3">产品案例</el-menu-item>-->
            <el-menu-item style="margin-left: 80px" index="4">联系我们</el-menu-item>
          </el-menu>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <div v-if="showContent == 1">
        <div style="margin-top: 20vh;">
          <span style="font-size: 50px;color: red">杭州凌恒软件有限公司</span>
          <br><br><br><br><br>
          <span style="font-size:40px">欢迎您的访问</span>
        </div>
      </div>
      <div v-if="showContent == 2">
        <p class="introduction">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;杭州凌恒软件有限公司成立于二零二零年五月，是一家专业为高校与各科研院所提供系统级平台开发的高科技企业。杭州凌恒自成立至今，一直依托自主研发的核心产品、优质高效的服务体系、以及度身定制的解决方案，为客户提供专业化、个性化、全方位的电子服务，业务涉及信息系统规划、软件研发、系统运营维护等。
          <br><br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;杭州凌恒广纳贤才，经过两年多的吸收和培养，已经形成一支十多人的专业技术团队。杭州凌恒通过若干个科研实验平台系统的开发和实施，积累了丰富的科研平台研发与应用经验，对技术、市场、管理等方面都具有专业的把握能力。
          <br><br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;杭州凌恒努力满足每一位客户的需求，以不断提升客户价值为己任，来实现公司与客户双赢。
        </p>
      </div>
<!--      <div v-if="showContent == 3">-->
<!--        <el-row type="flex" justify="center">-->
<!--          <el-col :span="6">-->
<!--            <el-card>-->
<!--              <el-image-->
<!--                  style="width: 100%; height: 200px"-->
<!--                  :src="pic"-->
<!--                  :fit="'fill'"></el-image>-->
<!--              <div style="padding: 14px;">-->
<!--                <el-link style="font-size: 20px" href="http://demo.lingheng.tech">某市儿童青少年心理健康诊疗平台</el-link>-->
<!--              </div>-->
<!--            </el-card>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--      </div>-->
      <div v-if="showContent == 4">
        <h1 style="margin-top: 30vh">Email: zhuzhilingwinnie@gmail.com</h1>
      </div>
    </el-main>
    <el-footer class="ipc">
      <div class="my-footer"><el-link class="link">版权所有C 2020-2024 杭州凌恒软件有限公司</el-link></div>
      <div class="my-footer"><el-link class="link" href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2023002362号-1 </el-link></div>
      <div class="my-footer"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUCAYAAACAl21KAAAAAXNSR0IArs4c6QAABQhJREFUOE9dlHtsU3Ucxc/v9vbePm7Xrmu7jTLGxmMPp8s2RkBGlCAEZUB84FAw0y3ig0hESRBBNARRIEYloOIQ4gwaUCeE4VgmLoFsyACdm3PsnT3a9bF1a2/f9/b+DCQS9PvfSb7nk2++JzkE/xtKz6g815wWklww3+8aWv57W+8aWQFbXJJdb7LPbIp5+3syly6dIGSBdK+V3Csopeqp4bqVHRdbnnL0u8pIfNziCyWSVElGWO0WMRbS+FJThNaS8ofqTJmr6wkh8X/9d0GUUhLyXi9sOFlbW3++K2fBzABXoAohVZHAWw0I58/HX2Ejfv3ZLa1YZu9ZV139LJ+2oPM/IEr7+IjPXdTd3LijpvbvNfPSI6q1yiDkJjdougGckYM85od+YzGakgrR0eKRKivyzuSXleznzL5+Qp6O37koHrpcfPN8Q82hT4fuT53FqN+a1wPaMI6gS0LCxIEVOMQGJsGlamDasQqH29Ph7ByJvf7S7LbcIusWYc4bnYQ2N7NiTnv5lzXOmo+PUcvOimFUeNvgu+CDbDYAcQWKpCChUyHhmsTMTXm4VLwSbx+I4sUKxrt5o6XKUlB2kfivH19Iwq27jvxie/TzWkX9wePteLj/FsJNHsQzTGAy9SAsAzoWQbx3HKZV2Rh4ZhWq9vBYv4ZIu7elXDCmrz5Ehs5vfdcU6dv6bW+R+cBxFnuf78E6qRcjJwYQfcAC/SNpEDKMkP8IQGrsh3V1Fq7OLcLWfXq8Usliy7opP01acoIM/LTtByHQUf5buIR/9SMb1i7qwc6VfXA1OCF7JRjmmcCbdaBiAly6FkJpGj48pcfpSzYcfZ9gua0rHmTvayQ9X1eN6sRBu2jPIxu+yIX/Zg+OLmlBaRbB5FAckejt+PVQRxNITuPQFxLwQv18cHlZ+P4dD5JdnTTKzRggt2qf87LukRRzjo3svb4Y33ziwEHpNCryA/BmWzEhUwhpSbBqVDBcc+Lsnyy2kMew/rXZ2LeiC8FBt0KtGYNkqG7bZUa8tTh1joW9OpGH6j0E2R2N2KDphsWsQK1lodVz4GxG+D3Ad11GtGYtxJH9PJZlTWDaHYgyxswGMnL2zQ7J01OgN2sIn27DZ1fm4ORxF6JuFzRIoCzZjyQtRbMnCZ6YHozejMoqDtufcADTEUTDksLZMtvJ+JXdTnGwN13xhyHo4iCzstA3LaCtPQhXIgWLZnlgIAGcu5mGySCHnGwem0odMMdGEIwScBYD1WbmDZGgo25HoK/x5bDDmRH3hlR8JIjU0gwQmwBZjoEJxiEHJSSSzaAWAxjnJELto4iyOnB2QdLbbYNCxqJDxOe7YeQjYxvF4Qu7Yj73jFD3NHiTGpZCO0hcRkyMgXBqaC06UABitxuRMIE6IxUMrxvW2vN3JWfn/kjojWPqgMH+ZHi86QDD+WbJYQolFAVnYAGGBYUKrBqQxQhiU2GoBD04WzISUgJykI7xWYXbrSJXR8S+w1bCYjdNOCtj4aAx7hXByBIII99ZVmk0QCyCmDcMyqqgNt9+uA6soAVrMEwyevtXSKgOEkqb2Zg4lR0a79wccQyVk3DAotYSPUkoXCIsM0TNQJEVEJ6nKq1aUSiNUrUQUqWkDatNGed4PumUxqQavVtso13vmadbHLmx6akHCedfaErVZTEyMXA6RiAsRxMKO8Elm0QizOgVJyOtMuRWc/Fch9VaLd6uon8Aess9ab0WKlMAAAAASUVORK5CYII=" alt=""></div>
      <div class="my-footer">
        <el-link class="link" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602012959" target="_blank">
          浙公网安备 33010602012959号
        </el-link>
      </div>

    </el-footer>
  </el-container>
</template>

<script>
import platform from '@/assets/platform.png'
import beian from '@/assets/beian.png'
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      activeIndex: '1',
      showContent: 1,
      pic: platform,
      beian: beian
    };
  },
  methods: {
    handleSelect(key) {
      this.showContent = key;
      console.log(this.showContent);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

body{
  margin: 0;
}

.el-container{
  min-height: 100vh;
}

.ipc{
  height: 2rem;
  background-color: #1f2d3d;
  text-align: center;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}

.link{
  font-size: 17px;
  color: #ffffff;
}
.introduction{
  padding-left: 20%;
  width: 60%;
  font-size: 20px;
  line-height: 50px;
  text-align: left;
}

.my-footer{
  display: inline-block;
  margin-left: 10px;
  margin-right: 10px;
  height: 100%;
  margin-top: 1rem;
}

</style>
